import { render, staticRenderFns } from "./deposit-edit.vue?vue&type=template&id=3764889c&scoped=true&"
import script from "./deposit-edit.vue?vue&type=script&lang=js&"
export * from "./deposit-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3764889c",
  null
  
)

export default component.exports